import { Helmet } from "react-helmet-async";
import { useLocation, useParams } from "react-router-dom";
import { stripLang } from "../../utils/localePath";

const ROBOTS =
  "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";

function SEO() {
  const location = useLocation();
  const { lang } = useParams();
  const locale = lang === "vi" ? "vi" : "en";
  const rest = stripLang(location.pathname);
  const suffix = rest === "/" ? "" : rest;

  const enUrl = `https://agent.quantera.vn/en${suffix}`;
  const viUrl = `https://agent.quantera.vn/vi${suffix}`;
  const canonicalUrl = `https://agent.quantera.vn/${locale}${suffix}`;
  const ogLocale = locale === "vi" ? "vi_VN" : "en_US";
  const ogLocaleAlt = locale === "vi" ? "en_US" : "vi_VN";

  return (
    <Helmet>
      <html lang={locale} />

      <meta name="robots" content={ROBOTS} />
      <meta name="googlebot" content={ROBOTS} />
      <meta name="bingbot" content={ROBOTS} />

      <link rel="canonical" href={canonicalUrl} />

      <link rel="alternate" hrefLang="en" href={enUrl} />
      <link rel="alternate" hrefLang="vi" href={viUrl} />
      <link rel="alternate" hrefLang="x-default" href={enUrl} />

      <meta property="og:locale" content={ogLocale} />
      <meta property="og:locale:alternate" content={ogLocaleAlt} />
      <meta property="og:url" content={canonicalUrl} />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "GoPaperless Agent",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Windows, macOS",
          url: canonicalUrl,
          image: "https://agent.quantera.vn/cover.png",
          inLanguage: locale === "vi" ? "vi-VN" : "en-US",
          publisher: {
            "@type": "Organization",
            name: "Quantera Joint Stock Company",
            url: "https://quantera.vn/",
          },
        })}
      </script>
    </Helmet>
  );
}

export default SEO;
